import { DatePicker } from "antd";
import styled from "styled-components";

export const StyledDatePicker = styled(DatePicker)`
  width: 100%;
  &.ant-picker.ant-picker-disabled{
   .ant-picker-input input{color: var(--input-text-disabled) !important;}
  }
`;

export const StyledRangePicker = styled(DatePicker.RangePicker)`
  width: 100%;
  &.ant-picker.ant-picker-disabled{
   .ant-picker-input input{color: var(--input-text-disabled) !important;}
  }
`;
